import React, { Component } from "react";
import "./NewHeader.css";
import CartDropDown from "../Cart/CartDropDown";
import { getGeoInfo, getCustomerLogin } from "../axios";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { connect, Provider } from "react-redux";
import { Base64 } from "js-base64";
import { countCartWithPackage } from "../AdminPackageDetails/PackageShowcase/commonFunction";

class NewHeader extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  constructor(props) {
    super(props);

    const { cookies } = props;
    this.state = {
      nav: false,
      country: "",
      country_code: "",
      currency: "",
      ip_address: "",
      customerEmail: cookies.get("userDetails") || "",
      customerEmailForData: localStorage.getItem("userDetails") || "abc",
      customerDetails: {},
      profileNew: false,
      profileNewAgain: false,
      cartProfileNewAgain: false,
      permissionArray: [],
      makebookingArray: ["make", "administrator"],
      cancelbookingArray: ["cancel", "administrator"],
    };
  }

  handleScroll = () => {
    if (this.props.page == "inner") {
      if (window.pageYOffset > 60) {
        if (!this.state.nav) {
          this.setState({ nav: true });
        }
      } else {
        if (this.state.nav) {
          this.setState({ nav: false });
        }
      }
    } else if (this.props.page == "inner_listing") {
      if (window.pageYOffset > 60) {
        if (!this.state.nav) {
          this.setState({ nav: true });
        }
      } else {
        if (this.state.nav) {
          this.setState({ nav: false });
        }
      }
    }
  };

  componentDidMount() {
    const userData = localStorage.getItem("userDetails") || "abc";

    if (userData == "abc") {
      var base_url = window.location.origin;
      window.location.href = base_url;
    } else {
      getGeoInfo().then(
        (data) => {
          this.setState({ country: data.country_name });
          this.setState({ country_code: data.country_calling_code });
          this.setState({ currency: data.currency });
          this.setState({ ip_address: data.ip });
        },
        (error) => {}
      );

      if (userData != null) {
        const { cookies } = this.props;

        let newData = JSON.parse(userData);
        getCustomerLogin(newData?.email).then(
          (data) => {
            this.setState({ customerDetails: data });
            if (data?.user == "nouser") {
              let Verified = "";
              if (data.agent.verified == 1) {
                Verified = true;
              }

              const dataSearch = {
                first_name: data.agent.first_name,
                last_name: data.agent.last_name,
                email: data.agent.email,
                country_code: data.agent.country_code,
                verified: Verified,
                uid: data.agent.id,
                agent_id: data.agent.id,
                permissionArray: 'agent',

              };

              let JsonData = JSON.stringify(dataSearch);

              localStorage.setItem("userDetails", JsonData);
            } else {
              let Verified = true;
              let  permissionArray = null;
              if (data?.user?.permission) {
                permissionArray = data?.user?.permission.split(",");
              } 
              const dataSearch = {
                first_name: data.user.user_first_name,
                last_name: data.user.user_last_name,
                email: data.user.user_email,
                country_code: data.user.country_code,
                verified: Verified,
                uid: data.user.user_id,
                agent_id: data.agent.id,
                permissionArray: permissionArray,
              };

              let JsonData = JSON.stringify(dataSearch);

              localStorage.setItem("userDetails", JsonData);

              if (data?.user?.permission) {
                const permissionArrayData = data?.user?.permission.split(",");
                this.setState({ permissionArray: permissionArrayData});
              } 
            }
          },
          (error) => {}
        );
      }
    }

    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.globalClickListener);
  }

  globalClickListener = (nativeEvent) => {
    this.setState(
      { profileNew: false, profileNewAgain: false, cartProfileNewAgain: false },
      () => {
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };

  OpenProfilelinkAgain = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ profileNewAgain: !prevState.profileNewAgain }),
      () => {
        if (this.state.profileNewAgain) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  OpenCartProfilelinkAgain = (syntheticEvent) => {
    syntheticEvent.stopPropagation();
    this.setState(
      (prevState) => ({ cartProfileNewAgain: !prevState.cartProfileNewAgain }),
      () => {
        if (this.state.cartProfileNewAgain) {
          window.addEventListener("click", this.globalClickListener);
        }
      }
    );
  };

  logoutChange = () => {
    localStorage.clear();
    // window.location.reload(true);
    var base_url = window.location.origin;
    window.location.href = base_url;
  };
  render() {
    
    return (
      <>
        <div
          className={`chHeaderWrapper ${
            this.state.nav == true ? " Nav" : " stickyHeader"
          }`}
          style={{ animation: "slideInDown 0.00s linear" }}
        >
          <div className="chHeaderContainer">
            <span className="logoContainer">
              <a className="chMmtLogo" href="/home">
                <img
                  src="images/logo/seyLogo.png"
                  alt="Holiday Seychelles"
                  style={{ width: 100 }}
                />
              </a>
            </span>

            <nav>
              <ul className="hsFlex_Bann font12">
                <li className="menu_Hotels">
                  <a
                    href={"/home/?t=" + Base64.btoa(1)}
                    smooth={true}
                    className=" hsFlex_Bann hsCenter column"
                  >
                    <span className="chNavIcon appendBottom2 chSprite chHotels "></span>
                    <span
                      className={`chNavText darkGreyText ${
                        this.props.tabName === 1 ? " active" : " "
                      }`}
                    >
                      {" "}
                      Accommodations{" "}
                    </span>
                  </a>
                </li>
                <li className="menu_Villasmore">
                  <a
                    href={"/home/?t=" + Base64.btoa(2)}
                    smooth={true}
                    className="hsFlex_Bann hsCenter column"
                  >
                    <span className="chNavIcon appendBottom2 chSprite chHomestays"></span>
                    <span
                      className={`chNavText darkGreyText ${
                        this.props.tabName === 2 ? " active" : " "
                      }`}
                    >
                      {" "}
                      Attractions &amp; Things to Do
                    </span>
                  </a>
                </li>

                <li className="menu_Holidays">
                  <a
                    href={"/home/?t=" + Base64.btoa(3)}
                    className="hsFlex_Bann hsCenter column"
                  >
                    <span className="chNavIcon appendBottom2 chSprite chHolidays"></span>
                    <span
                      className={`chNavText darkGreyText ${
                        this.props.tabName === 3 ? " active" : " "
                      }`}
                    >
                      {" "}
                      Packages{" "}
                    </span>
                  </a>
                </li>

                <li className="menu_Trains">
                  <a
                    href={"/home/?t=" + Base64.btoa(4)}
                    className="hsFlex_Bann hsCenter column"
                  >
                    <span className="chNavIcon appendBottom2 chSprite chTrains"></span>
                    <span
                      className={`chNavText darkGreyText ${
                        this.props.tabName === 4 ? " active" : " "
                      }`}
                    >
                      {" "}
                      Land & Ferry Transfers{" "}
                    </span>
                  </a>
                </li>

                <li className="menu_Buses">
                  <a
                    href={"/home/?t=" + Base64.btoa(5)}
                    className="hsFlex_Bann hsCenter column"
                  >
                    <span className="chNavIcon appendBottom2 chBuses"></span>
                    <span
                      className={`chNavText darkGreyText ${
                        this.props.tabName === 5 ? " active" : " "
                      }`}
                    >
                      {" "}
                      Liveaboard{" "}
                    </span>
                  </a>
                </li>
              </ul>
            </nav>

            <ul className="userSection pushRight">
              {this.state.customerEmailForData == "abc" ? (
                <li
                  className="hsFlex_Bann hsCenter font10 hsRelative lhUser"
                  onClick={this.openModal}
                >
                  <div className="hsFlex_Bann column flexOne latoBold">
                    <p className="appendBottom3_Header">
                      {" "}
                      <img
                        src="images/icon/favicon.ico"
                        className="loginIcon"
                      />{" "}
                      Login or Create Account
                    </p>
                  </div>
                </li>
              ) : (
                <li
                  className="hs-LoginFlex hsCenter font10 hsRelative hsUser userLoggedIn"
                  onClick={this.OpenProfilelinkAgain}
                >
                  {this.state.customerDetails?.agent?.profile_pic == "" ? (
                    <span className="userNameIcon whiteText hs-LoginFlex perfectCenter latoBlack appendRight10">
                      <span>
                        {this.state.customerDetails?.user == "nouser"
                          ? this.state.customerDetails?.agent?.first_name.charAt(
                              0
                            )
                          : this.state.customerDetails?.user?.user_first_name.charAt(
                              0
                            )}
                      </span>
                    </span>
                  ) : (
                    <span className="userNameImage  appendRight10">
                      <img
                        style={{ width: "100%", borderRadius: "100%" }}
                        src={this.state.customerDetails?.agent?.profile_pic}
                      />
                    </span>
                  )}

                  <div className="hs-LoginFlex column userNameText  latoBold">
                    <p
                      data-cy="loggedInUser"
                      className="appendBottom3 truncate customerName"
                    >
                      Hey{" "}
                      {this.state.customerDetails?.user == "nouser"
                        ? this.state.customerDetails?.agent?.first_name
                        : this.state.customerDetails?.user?.user_first_name}
                    </p>
                  </div>
                  {this.state.profileNewAgain && (
                      this.state.customerDetails?.user == "nouser" ? (
                    <div className="userDropdown fadeInDown hs-LoginFlex column dropbanner">
                      <a
                        className="userItems hs-LoginFlex"
                        href="/PlanTrips"
                      >
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Bookings
                          </p>
                          <p className="font12 lineHeight16 blackText">
                            See booking details, planned your own trip, Cancel
                            Booking &amp; more.
                          </p>
                        </div>
                      </a>
                      <a className="userItems hs-LoginFlex" href="/mytripplan">
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Trip Plan
                          </p>
                        </div>
                      </a>
                        <a
                          className="userItems hs-LoginFlex"
                          href="/Profile"
                        >
                          <span className="landingSprite userItemMyProfile appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              My Profile
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              Manage your profile, login details and password
                            </p>
                          </div>
                        </a>
                      <a
                        className="userItems hs-LoginFlex"
                        href="/subagentview"
                      >
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Sub Agents
                          </p>
                        </div>
                      </a>
                      <a className="userItems hs-LoginFlex" href="/agentuser">
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Users
                          </p>
                        </div>
                      </a>
                      <a
                        className="userItems hs-LoginFlex appendBottom10"
                        onClick={this.logoutChange}
                      >
                        <span className="landingSprite userItemLogout appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                            Logout
                          </p>
                        </div>
                      </a>
                    </div>
                      ):(
                      <div className="userDropdown fadeInDown hs-LoginFlex column dropbanner">
                      <a
                        className="userItems hs-LoginFlex"
                        href="/PlanTrips"
                      >
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Bookings
                          </p>
                          <p className="font12 lineHeight16 blackText">
                            See booking details, planned your own trip, Cancel
                            Booking &amp; more.
                          </p>
                        </div>
                      </a>
                      {this.state.makebookingArray.some(value => this.state.permissionArray.includes(value))&&( 
                      <a className="userItems hs-LoginFlex" href="/mytripplan">
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Trip Plan
                          </p>
                        </div>
                      </a>)}

                        <a
                          className="userItems hs-LoginFlex"
                          href="/Profileuser"
                        >
                          <span className="landingSprite userItemMyProfile appendRight20"></span>
                          <div>
                            <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                              My Profile
                            </p>
                            <p className="font12 lineHeight16 blackText">
                              Manage your profile
                            </p>
                          </div>
                        </a>
                        {this.state.permissionArray.includes("administrator") &&( 
                      <a
                        className="userItems hs-LoginFlex"
                        href="/subagentview"
                      >
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Sub Agents
                          </p>
                        </div>
                      </a>
                        )}
                        {this.state.permissionArray.includes("administrator") &&( 
                      <a className="userItems hs-LoginFlex" href="/agentuser">
                        <span className="landingSprite userItemMyTrips appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5">
                            My Users
                          </p>
                        </div>
                      </a>
                        )}
                      <a
                        className="userItems hs-LoginFlex appendBottom10"
                        onClick={this.logoutChange}
                      >
                        <span className="landingSprite userItemLogout appendRight20"></span>
                        <div>
                          <p className="font16 latoBold blackText appendBottom5 hs-LoginFlex hsCenter">
                            Logout
                          </p>
                        </div>
                      </a>
                    </div>)
                  )}
                </li>
              )}

              <li className="hsFlex_Bann hsCenter font10 hsRelative">
                <div
                  className="hsFlex_Bann column flexOne latoBold"
                  onClick={this.OpenCartProfilelinkAgain}
                >
                  <p className="appendBottom3_Header">
                    <a
                      href="javascript:void(0)"
                      class="cart position-relative d-inline-flex"
                      aria-label="View your shopping cart"
                    >
                      <img
                        src="images/cart/ecommerce.png"
                        className=" travel_blog appendRight10"
                      />
                      <span class="cart-basket d-flex align-items-center justify-content-center">
                        {countCartWithPackage(this.props.showcart.cardItems.cardData)}
                      </span>
                    </a>
                  </p>
                </div>
                {this.state.cartProfileNewAgain && (
                  <CartDropDown
                    showcart={this.props.showcart.cardItems.cardData}
                  ></CartDropDown>
                )}
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => {};
const mapStateToProps = (state, ownProps = {}) => {
  return {
    showcart: state,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(NewHeader));
